export const tblData = [
	{
		'year': 1,
		'investedAmount': 12000,
		'maturityValue': 12397,
		'gainLoss': 397,
		'periods': [
			{
				'period': 1,
				'investedAmount': 1000,
				'maturityValue': 1005,
				'gainLoss': 5
			},
			{
				'period': 2,
				'investedAmount': 2000,
				'maturityValue': 2015,
				'gainLoss': 15
			},
			{
				'period': 3,
				'investedAmount': 3000,
				'maturityValue': 3030,
				'gainLoss': 30
			},
			{
				'period': 4,
				'investedAmount': 4000,
				'maturityValue': 4050,
				'gainLoss': 50
			},
			{
				'period': 5,
				'investedAmount': 5000,
				'maturityValue': 5076,
				'gainLoss': 76
			},
			{
				'period': 6,
				'investedAmount': 6000,
				'maturityValue': 6106,
				'gainLoss': 106
			},
			{
				'period': 7,
				'investedAmount': 7000,
				'maturityValue': 7141,
				'gainLoss': 141
			},
			{
				'period': 8,
				'investedAmount': 8000,
				'maturityValue': 8182,
				'gainLoss': 182
			},
			{
				'period': 9,
				'investedAmount': 9000,
				'maturityValue': 9228,
				'gainLoss': 228
			},
			{
				'period': 10,
				'investedAmount': 10000,
				'maturityValue': 10279,
				'gainLoss': 279
			},
			{
				'period': 11,
				'investedAmount': 11000,
				'maturityValue': 11336,
				'gainLoss': 336
			},
			{
				'period': 12,
				'investedAmount': 12000,
				'maturityValue': 12397,
				'gainLoss': 397
			}
		]
	},
	{
		'year': 2,
		'investedAmount': 24000,
		'maturityValue': 25559,
		'gainLoss': 1559,
		'periods': [
			{
				'period': 13,
				'investedAmount': 13000,
				'maturityValue': 13464,
				'gainLoss': 464
			},
			{
				'period': 14,
				'investedAmount': 14000,
				'maturityValue': 14537,
				'gainLoss': 537
			},
			{
				'period': 15,
				'investedAmount': 15000,
				'maturityValue': 15614,
				'gainLoss': 614
			},
			{
				'period': 16,
				'investedAmount': 16000,
				'maturityValue': 16697,
				'gainLoss': 697
			},
			{
				'period': 17,
				'investedAmount': 17000,
				'maturityValue': 17786,
				'gainLoss': 786
			},
			{
				'period': 18,
				'investedAmount': 18000,
				'maturityValue': 18880,
				'gainLoss': 880
			},
			{
				'period': 19,
				'investedAmount': 19000,
				'maturityValue': 19979,
				'gainLoss': 979
			},
			{
				'period': 20,
				'investedAmount': 20000,
				'maturityValue': 21084,
				'gainLoss': 1084
			},
			{
				'period': 21,
				'investedAmount': 21000,
				'maturityValue': 22194,
				'gainLoss': 1194
			},
			{
				'period': 22,
				'investedAmount': 22000,
				'maturityValue': 23310,
				'gainLoss': 1310
			},
			{
				'period': 23,
				'investedAmount': 23000,
				'maturityValue': 24432,
				'gainLoss': 1432
			},
			{
				'period': 24,
				'investedAmount': 24000,
				'maturityValue': 25559,
				'gainLoss': 1559
			}
		]
	},
	{
		'year': 3,
		'investedAmount': 36000,
		'maturityValue': 39533,
		'gainLoss': 3533,
		'periods': [
			{
				'period': 25,
				'investedAmount': 25000,
				'maturityValue': 26692,
				'gainLoss': 1692
			},
			{
				'period': 26,
				'investedAmount': 26000,
				'maturityValue': 27830,
				'gainLoss': 1830
			},
			{
				'period': 27,
				'investedAmount': 27000,
				'maturityValue': 28975,
				'gainLoss': 1975
			},
			{
				'period': 28,
				'investedAmount': 28000,
				'maturityValue': 30124,
				'gainLoss': 2124
			},
			{
				'period': 29,
				'investedAmount': 29000,
				'maturityValue': 31280,
				'gainLoss': 2280
			},
			{
				'period': 30,
				'investedAmount': 30000,
				'maturityValue': 32441,
				'gainLoss': 2441
			},
			{
				'period': 31,
				'investedAmount': 31000,
				'maturityValue': 33609,
				'gainLoss': 2609
			},
			{
				'period': 32,
				'investedAmount': 32000,
				'maturityValue': 34782,
				'gainLoss': 2782
			},
			{
				'period': 33,
				'investedAmount': 33000,
				'maturityValue': 35961,
				'gainLoss': 2961
			},
			{
				'period': 34,
				'investedAmount': 34000,
				'maturityValue': 37145,
				'gainLoss': 3145
			},
			{
				'period': 35,
				'investedAmount': 35000,
				'maturityValue': 38336,
				'gainLoss': 3336
			},
			{
				'period': 36,
				'investedAmount': 36000,
				'maturityValue': 39533,
				'gainLoss': 3533
			}
		]
	},
	{
		'year': 4,
		'investedAmount': 48000,
		'maturityValue': 54368,
		'gainLoss': 6368,
		'periods': [
			{
				'period': 37,
				'investedAmount': 37000,
				'maturityValue': 40735,
				'gainLoss': 3735
			},
			{
				'period': 38,
				'investedAmount': 38000,
				'maturityValue': 41944,
				'gainLoss': 3944
			},
			{
				'period': 39,
				'investedAmount': 39000,
				'maturityValue': 43159,
				'gainLoss': 4159
			},
			{
				'period': 40,
				'investedAmount': 40000,
				'maturityValue': 44380,
				'gainLoss': 4380
			},
			{
				'period': 41,
				'investedAmount': 41000,
				'maturityValue': 45607,
				'gainLoss': 4607
			},
			{
				'period': 42,
				'investedAmount': 42000,
				'maturityValue': 46840,
				'gainLoss': 4840
			},
			{
				'period': 43,
				'investedAmount': 43000,
				'maturityValue': 48079,
				'gainLoss': 5079
			},
			{
				'period': 44,
				'investedAmount': 44000,
				'maturityValue': 49324,
				'gainLoss': 5324
			},
			{
				'period': 45,
				'investedAmount': 45000,
				'maturityValue': 50576,
				'gainLoss': 5576
			},
			{
				'period': 46,
				'investedAmount': 46000,
				'maturityValue': 51834,
				'gainLoss': 5834
			},
			{
				'period': 47,
				'investedAmount': 47000,
				'maturityValue': 53098,
				'gainLoss': 6098
			},
			{
				'period': 48,
				'investedAmount': 48000,
				'maturityValue': 54368,
				'gainLoss': 6368
			}
		]
	},
	{
		'year': 5,
		'investedAmount': 60000,
		'maturityValue': 70119,
		'gainLoss': 10119,
		'periods': [
			{
				'period': 49,
				'investedAmount': 49000,
				'maturityValue': 55645,
				'gainLoss': 6645
			},
			{
				'period': 50,
				'investedAmount': 50000,
				'maturityValue': 56928,
				'gainLoss': 6928
			},
			{
				'period': 51,
				'investedAmount': 51000,
				'maturityValue': 58218,
				'gainLoss': 7218
			},
			{
				'period': 52,
				'investedAmount': 52000,
				'maturityValue': 59514,
				'gainLoss': 7514
			},
			{
				'period': 53,
				'investedAmount': 53000,
				'maturityValue': 60817,
				'gainLoss': 7817
			},
			{
				'period': 54,
				'investedAmount': 54000,
				'maturityValue': 62126,
				'gainLoss': 8126
			},
			{
				'period': 55,
				'investedAmount': 55000,
				'maturityValue': 63441,
				'gainLoss': 8441
			},
			{
				'period': 56,
				'investedAmount': 56000,
				'maturityValue': 64764,
				'gainLoss': 8764
			},
			{
				'period': 57,
				'investedAmount': 57000,
				'maturityValue': 66092,
				'gainLoss': 9092
			},
			{
				'period': 58,
				'investedAmount': 58000,
				'maturityValue': 67428,
				'gainLoss': 9428
			},
			{
				'period': 59,
				'investedAmount': 59000,
				'maturityValue': 68770,
				'gainLoss': 9770
			},
			{
				'period': 60,
				'investedAmount': 60000,
				'maturityValue': 70119,
				'gainLoss': 10119
			}
		]
	}
];

export const infoMsg = {
	sipFrequency: 'Indicates how often you make investments (e.g., daily, weekly, monthly, quarterly',
	sipAmount: 'the fixed monthly amount you plan to invest during your SIP',
	investmentPeriod: 'Investment period in Years',
	expectedReturn: 'The yearly growth rate you expect from your calculator investment'
};
